import { Box, Typography } from "@mui/material";

//This component is responsible for rendering the objectives static text. 
export default function ObjectivesStaticText() {
    return (
        <>
            <Typography variant="h6" color="black" component="div">
                <Box sx={{ fontWeight: 'bold' }}>Develop Learning Objectives</Box>
            </Typography>
            <Typography variant="body1" component="div" sx={{ mt:2, mb:1, width: "60%", minWidth: 255 }}>
                Develop S.M.A.R.T. (Specific, Measurable, Achievable, Realistic, Timebound) objectives to help you achieve your goals and improve in the areas you have assessed that need improvement.
            </Typography>
        </>
    );
}